import { deleteMilestone } from 'resources/milestone/workflow';
import auditService from 'resources/audit/audit.service';
import kitService from 'resources/listedkit/listedkit.service';


export const deleteListedKit = async (listedKit) => {
  await Promise.all([
    // remove all related Milestones and their tasks
    ...listedKit.milestone_ids.map((milestoneId) => deleteMilestone(milestoneId)),
    // remove all related Audits
    auditService.removeKitAudits(listedKit.id),
  ]);

  return kitService.removeListedKit(listedKit.id);
};